<app-pageheader Title="Car Counters">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/carcounters/searches"
  [AllowEdit]="true" EditUrl="/parking/guidance/carcounters/:id/edit" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="CarCounter">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>